import classNames                              from 'classnames';
import React, { FC }                           from 'react';
import { Icon, SemanticICONS }                 from 'semantic-ui-react';
import { ComponentWithAsTagProp, CorvalColor } from '../../../../types/componentPropTypes';
import { ClassValue }                          from 'classnames/types';

interface FinePrintMessageProps extends ComponentWithAsTagProp {
	fadeIn?: boolean,
	color?: CorvalColor,
	icon?: SemanticICONS,
	className?: ClassValue,
	
	[ additionalProps: string ]: any
}

const defaultProps: FinePrintMessageProps = {
	as:        'p',
	fadeIn:    true,
	color:     null,
	icon:      null,
	className: null,
}

/* Provides an italic, muted message with an optional information icon. */
const FinePrintMessage: FC<FinePrintMessageProps> = ( props ) => {
	
	// dynamic tag
	let Tag     = props.as,
	    classes = classNames( {
		    'text--fine-print':                   true,
		    'fade-in':                            props.fadeIn,
		    [ `text--colored-${ props.color }` ]: props.color
	    }, props.className );
	
	return (
		<Tag className={ classes }>
			{ props.icon && <Icon name={ props.icon }/> } { props.children }
		</Tag>
	)
};

FinePrintMessage.defaultProps = defaultProps;

export { FinePrintMessage }
